export const employeeColumnMap = {
  "Unique ID": "uniqueId",
  "Full Name": "fullName",
  "Alias Name": "aliasName",
  "Salary Type": "salaryType",
  Salary: "salary",
  // Company: "companyCode",
  Location: "locationCode",
  "MOM Trade": "momTrade",
  Trade: "netcoTrade",
  Department: "departmentCode",
  Designation: "designationCode",
  "Employee Type": "employeeType",
  "Working Mode": "employeeWorkType",
  "Employment Type": "employmentType",
  "Join Date": "joinDate",
  "Contract Expiry": "contractExpiryDate",
  Nationality: "nationality",
  DOB: "dob",
  "Pass Type": "passCode",
  "NRIC/FIN Number": "nricNumber",
  "NRIC/FIN Issue Date": "passIssuedDate",
  "NRIC/FIN Expiry Date": "passExpiryDate",
  "Work Permit Number": "workPermitNumber",
  "Work Permit Renewal Date": "workPermitRenewalDate",
  "S Pass Number": "sPassNumber",
  "Levy Amount Types": "levyAmountTypes",
  "Levy Types": "levyTypes",
  "Levy Amount": "levyAmount",
  "PCP Expiry Date": "pcpExpiryDate",
  "PCP Clinic": "pcpClinic",
  Sector: "sector",
  "Passport Number": "passportNumber",
  "Passport Issued Place": "passPortIssuedPlace",
  "Passport Issued Date": "passPortIssuedDate",
  "Passport Expiry Date": "passPortExpiryDate",
  "Report To": "reportTo",
  "Exclude Time": "excludeTime",
  "NS Eligible": "nsEligible",
  "Probation Start Date": "probationPeriodStart",
  "Probation End Date": "probationPeriodEnd",
  "Notice Period": "lengthofNoticePeriod",
  "Payment Mode": "paymentMode",
  // "Pay Amount Type": "basicPayAmountType",
  "Bank Name": "bankName",
  "Account No": "accountNo",
  "Shift Code": "groups",
  Qualification: "academicQualification",
  Gender: "gender",
  "Marital Status": "maritalStatus",
  "Father Name": "fatherName",
  "Mother Name": "motherName",
  "Emergency Contact": "emergencyContactPerson",
  // "Relationship": "relationship",
  "Having Dependants": "havingDependants",
  "Having Kids": "havingKids",
  "Eating Habit": "eatingHabit",
  "Accommodation by Company": "accommodationByCompany",
  "Contact No": "hpno",
  "Local Contact No": "localContactNumber",
  "Overseas Contact No": "overseasContactNumber",
  Email: "email",
  "Personal Email": "personalEmail",
  // "IC No": "icno",
  "Address 1": "address1",
  "Address 2": "address2",
  "Address 3": "address3",
  Country: "country",
  "Postal Code": "postalCode",
  Race: "race",
  // "Office No": "officeNo",
  "Blood Group": "bloodGroup",
  Religion: "religion",
  Remarks: "remarks",
  "PPE Size": "ppeSize",
  "Shoe Size": "shoeSize",
  "PPE Remarks": "ppeRemarks",
  "Employment Status": "employmentStatus",
  "Skilled/Unskilled": "skilledOrUnSkilled",
  "Confirmation Date": "confirmationDate",
  "Resigned Date": "resignedDate",
  "Job Title": "jobTitle",
  Project: "projectCode",
  "Residential Type": "residentialType",
  "Contribution Code": "contributionCode",
  "PR Date": "prDate",
  "PR CPF Type": "prcpfType",
  "CPF Entitled": "cpfEntitled",
  "Contributes SDL": "contributesSDL",
  "SDL Breakdown": "sdlBreakdown",
  "Fund Donation": "fundDonation",
  // "Working Days/Week": "noofworkingDaysPerWeek",
  "Has OT Pay": "haveOverTimePay",
  "OT Pay for Extra Hours": "haveOverTimePayForExtraHours",
  // "OT Day Salary": "otDaySalary",
  // "OT Paid in Days": "otPaidInDays",
  // "OT Hourly Salary": "otHourlySalary",
  // "Daily Allowance": "dailyAllowance",
  "OT1 Pay Rate": "oT1PayRate",
  "OT2 Pay Rate": "oT2PayRate",
  "OT3 Pay Rate": "oT3PayRate",
  "Extra Hours Rate": "extraHoursRate",
  "Need Attendance": "haveNeedAttendance",
  "Login Permission": "haveLoginPermission",
  "Login Username": "loginUserName",
  "Rest Day": "restDay",
  "Skill Set": "skillSet",
  "Working Hours/Day": "workingHoursPerDay",
  "Work Days/Week": "workDayPerWeek",
  "Working Timing/Day": "workingTimingPerDay",
  "Monday Hours": "monday",
  "Tuesday Hours": "tuesday",
  "Wednesday Hours": "wednesday",
  "Thursday Hours": "thursday",
  "Friday Hours": "friday",
  "Saturday Hours": "saturday",
  "Sunday Hours": "sunday",
  "Monday Mode": "mondayWorkingMode",
  "Tuesday Mode": "tuesdayWorkingMode",
  "Wednesday Mode": "wednesdayWorkingMode",
  "Thursday Mode": "thursdayWorkingMode",
  "Friday Mode": "fridayWorkingMode",
  "Saturday Mode": "saturdayWorkingMode",
  "Sunday Mode": "sundayWorkingMode",
  "Have Less Time Deduction": "haveLessTimeDeduction",
  "Is Active": "isActive",
  "Have FullPay": "haveFullPay",
  "OT Hourly Salary": "otHourlySalary",
  "OT Day Salary": "otDaySalary",
  "Daily Allowance": "dailyAllowance",
  "Create User": "createUser",
  "Create Date": "createDate",
  "Modify User": "modifyUser",
  "Modify Date": "modifyDate",
  "Pass Issue Date": "passIssueDate",
  "Pass Expiry Date": "passExpiryDate",
  "Noof Working Days Per Week": "noofworkingDaysPerWeek",
  "Contract Type": "contractType",
  "Default Shift": "defaultShift",
  "Course Name": "courseName",
  "Certificate Number": "certificateNumber",
  Abbreviation: "abbreviation",
  "Issue Date": "issueDate",
  "Expiry Date": "expiryDate",
  // Remarks: "remark",
};

// export const employeeColumnMap = {
//   "Unique ID": "uniqueId",
//   "Full Name": "fullName",
//   "Employee Type": "employeeType",
//   "IC No": "icno",
//   "FIN Number": "finNumber",
//   Location: "locationCode",
//   DOB: "dob",
//   Gender: "gender",
//   "Marital Status": "maritalStatus",
//   Nationality: "nationality",
//   Race: "race",
//   Religion: "religion",
//   "Address 1": "address1",
//   "Address 2": "address2",
//   "Address 3": "address3",
//   Country: "country",
//   "Postal Code": "postalCode",
//   "HP No": "hpno",
//   "Office No": "officeNo",
//   Email: "email",
//   "Personal Email": "personalEmail",
//   "Local Contact No": "localContactNumber",
//   "Overseas Contact No": "overseasContactNumber",
//   "NS Eligible": "nsEligible",
//   "Employment Status": "employmentStatus",
//   "Skilled/Unskilled": "skilledOrUnSkilled",
//   "Join Date": "joinDate",
//   "Confirmation Date": "confirmationDate",
//   "Resigned Date": "resignedDate",
//   Designation: "designationCode",
//   Department: "departmentCode",
//   "Shift Code": "groups",
//   "Job Title": "jobTitle",
//   "Report To": "reportTo",
//   Project: "projectCode",
//   "PPE Size": "ppeSize",
//   "Shoe Size": "shoeSize",
//   "PPE Remarks": "ppeRemarks",
//   "Pass Code": "passCode",
//   "Pass Issue Date": "passIssueDate",
//   "Pass Expiry Date": "passExpiryDate",
//   "Residential Type": "residentialType",
//   "Contribution Code": "contributionCode",
//   "PR Date": "prDate",
//   "PR CPF Type": "prcpfType",
//   "CPF Entitled": "cpfEntitled",
//   "Contributes SDL": "contributesSDL",
//   "SDL Breakdown": "sdlBreakdown",
//   "Fund Donation": "fundDonation",
//   "Working Days/Week": "noofworkingDaysPerWeek",
//   "Payment Mode": "paymentMode",
//   "Salary Type": "salaryType",
//   "Basic Salary": "basicSalary",
//   "Day Salary": "daySalary",
//   "Hourly Salary": "hourlySalary",
//   "Has OT Pay": "haveOverTimePay",
//   "OT Pay for Extra Hours": "haveOverTimePayForExtraHours",
//   "OT1 Pay Rate": "oT1PayRate",
//   "OT2 Pay Rate": "oT2PayRate",
//   "OT3 Pay Rate": "oT3PayRate",
//   "Extra Hours Rate": "extraHoursRate",
//   "Need Attendance": "haveNeedAttendance",
//   "Login Permission": "haveLoginPermission",
//   "Login Username": "loginUserName",
//   "Rest Day": "restDay",
//   "Pay Amount Type": "basicPayAmountType",
//   "Bank Name": "bankName",
//   "Account No": "accountNo",
//   "Skill Set": "skillSet",
//   "Working Hours/Day": "workingHoursPerDay",
//   "Work Days/Week": "workDayPerWeek",
//   "Working Timing/Day": "workingTimingPerDay",
//   "Notice Period": "lengthofNoticePeriod",
//   Remarks: "remarks",
//   "Monday Hours": "monday",
//   "Tuesday Hours": "tuesday",
//   "Wednesday Hours": "wednesday",
//   "Thursday Hours": "thursday",
//   "Friday Hours": "friday",
//   "Saturday Hours": "saturday",
//   "Sunday Hours": "sunday",
//   "Monday Mode": "mondayWorkingMode",
//   "Tuesday Mode": "tuesdayWorkingMode",
//   "Wednesday Mode": "wednesdayWorkingMode",
//   "Thursday Mode": "thursdayWorkingMode",
//   "Friday Mode": "fridayWorkingMode",
//   "Saturday Mode": "saturdayWorkingMode",
//   "Sunday Mode": "sundayWorkingMode",
//   "Eating Habit": "eatingHabit",
//   "Having Kids": "havingKids",
//   "Having Dependants": "havingDependants",
//   "Accommodation by Company": "accommodationByCompany",
//   "Qualification": "academicQualification",
//   "Is Active": "isActive",
//   "Create User": "createUser",
//   "Create Date": "createDate",
//   "Modify User": "modifyUser",
//   "Modify Date": "modifyDate",
//   "Have Less Time Deduction": "haveLessTimeDeduction",
// };
